export class NavigationTabs {
	constructor(state, options = {}) {
		this.state = state;
		this.options = options;
		this.element = null;
		this._unsubscribe = null;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = 'liveChat-panel-nav';

		this._updateContent();
		this._attachEvents();

		this._unsubscribe = this.state.subscribe((type) => {
			if (type === 'viewChange' || type === 'unreadCountChange') {
				this._updateActiveTab();
			} else if (type === 'settingsUpdate') {
				this._updateContent();
				this._updateActiveTab();
			}
		});

		return this.element;
	}

	_getTabs() {
		const tabs = [];

		if (this.state.homeModuleEnabled !== false) {
			tabs.push({ id: 'home', label: 'Home', icon: 'ph:house-simple' });
		}

		if (this.state.messagesModuleEnabled !== false) {
			tabs.push({
				id: 'messages',
				label: 'Messages',
				icon: 'ph:chats',
				badge: this.state.unreadCount,
			});
		}

		if (this.state.enableHelp) {
			tabs.push({ id: 'help', label: 'Help', icon: 'ph:books' });
		}

		if (this.state.enableChangelog) {
			tabs.push({
				id: 'changelog',
				label: 'Updates',
				icon: 'ph:megaphone',
			});
		}

		return tabs;
	}

	_updateContent() {
		const tabs = this._getTabs();
		const tabsHtml = tabs
			.map((tab) => {
				const isActive = this.state.currentView === tab.id;
				const badgeHtml =
					tab.badge && tab.badge > 0
						? `<span class="liveChat-nav-badge">${tab.badge > 9 ? '9+' : tab.badge}</span>`
						: '';

				return `
					<button class="liveChat-nav-tab ${isActive ? 'active' : ''}" data-tab="${tab.id}">
						<span class="liveChat-nav-icon">
							<iconify-icon icon="${tab.icon}" width="22" height="22"></iconify-icon>
						</span>
						<span class="liveChat-nav-label">${tab.label}</span>
						${badgeHtml}
					</button>
				`;
			})
			.join('');

		this.element.innerHTML = `
			<div class="liveChat-nav-tabs">
				${tabsHtml}
			</div>
			<div class="liveChat-nav-footer">
				<a href="https://product7.io" target="_blank" rel="noopener noreferrer" class="liveChat-powered-by">
					<svg width="12" height="14" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M15.0615 5.28044C8.5161 4.42949 3.30825 11.1456 5.89967 17.6588C6.9321 20.2538 9.06268 22.2644 11.8777 23.1968C16.2682 24.6507 18.4038 22.3222 19.0483 23.9691C19.4055 24.8894 18.7282 25.3209 17.988 25.4938C10.9146 27.15 5.15304 22.7566 3.5869 17.5531C1.52205 10.6941 5.98684 4.6667 11.3483 3.41065C17.8801 1.88094 24.0325 6.19355 24.3926 12.7175C24.7448 19.0921 18.6217 24.5978 11.927 22.2036C10.8789 21.8285 8.8419 20.6682 8.46823 19.858C8.06026 18.9727 8.80261 18.1725 9.68285 18.3576C10.2223 18.4726 10.3116 18.8706 11.3161 19.5372C14.4549 21.6213 19.1276 20.6132 21.2046 17.0972C23.991 12.3817 21.0481 6.05351 15.06 5.27758L15.0615 5.28044Z" fill="#21244A"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M15.2492 2.19833C11.944 1.71463 8.88819 3.07214 6.91479 4.49682C2.27067 7.85488 0.76169 14.5038 3.49672 19.8731C4.08535 21.0096 4.84379 22.0497 5.7459 22.9576L7.16343 24.2515C7.67214 24.9131 7.27203 25.7176 6.64115 25.9269C5.13502 26.4271 2.0499 21.8172 1.42044 20.5383C0.0872204 17.8297 -0.312889 14.9047 0.242977 11.503C1.66908 2.77063 11.221 -2.51652 19.7197 1.21021C27.7548 4.73331 30.2733 15.4555 23.9351 22.0773C23.3107 22.7296 21.6352 24.4823 20.6278 23.8907C20.0076 23.5263 19.8933 22.6446 20.5192 22.1238C21.0301 21.6986 21.4759 21.435 21.9896 20.9734C23.6665 19.4688 25.2562 16.8752 25.3477 13.5636C25.4427 10.2055 24.1266 7.5848 22.3904 5.74859C20.6392 3.89665 18.6751 2.69919 15.2456 2.19691L15.2492 2.19833Z" fill="#F69F06"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M8.48332 27.2217C7.93817 26.265 8.89987 25.3776 10.1352 25.8641C15.5653 27.9926 18.3081 25.5269 19.0255 27.0823C19.2655 27.6039 19.0448 28.1619 18.7354 28.3863C17.9895 28.9257 14.82 28.9343 13.9262 28.8714C12.9071 28.8053 11.897 28.6377 10.9111 28.3713C10.0888 28.1348 8.88057 27.9247 8.48189 27.2281L8.48332 27.2217Z" fill="#21244A"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8722 31.0607C15.7765 32.1381 14.579 32.0331 13.5766 31.9545C12.5742 31.8759 11.5203 31.8502 11.601 30.7013C11.6789 29.5882 12.8035 29.7532 13.8274 29.8332C14.4425 29.8811 15.9951 29.681 15.8722 31.0607Z" fill="#21244A"/>
					</svg>
					Powered by <strong>Product7</strong>
				</a>
			</div>
		`;
	}

	_attachEvents() {
		this.element.addEventListener('click', (e) => {
			const tab = e.target.closest('.liveChat-nav-tab');
			if (tab) {
				const tabId = tab.dataset.tab;
				this.state.setView(tabId);
			}
		});
	}

	_updateActiveTab() {
		const tabs = this.element.querySelectorAll('.liveChat-nav-tab');
		tabs.forEach((tab) => {
			const isActive = tab.dataset.tab === this.state.currentView;
			tab.classList.toggle('active', isActive);

			if (tab.dataset.tab === 'messages') {
				const existingBadge = tab.querySelector('.liveChat-nav-badge');
				if (existingBadge) existingBadge.remove();

				if (this.state.unreadCount > 0) {
					const badge = document.createElement('span');
					badge.className = 'liveChat-nav-badge';
					badge.textContent =
						this.state.unreadCount > 9 ? '9+' : this.state.unreadCount;
					tab.appendChild(badge);
				}
			}
		});
	}

	destroy() {
		if (this._unsubscribe) {
			this._unsubscribe();
		}
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
